export default "__VITE_ASSET__Bbcw0QwU__"